import { Controller } from "@hotwired/stimulus"
import MarkdownIt from "markdown-it"

export default class extends Controller {
  static values = {
    originalContent: { type: String, default: '' }
  }

  connect() {
    this.md = new MarkdownIt({
      html: false, // Disable HTML tags in source
      breaks: true, // Convert '\n' in paragraphs into <br>
      linkify: false, // Autoconvert URL-like text to links
      typographer: true, // Enable some language-neutral replacement + quotes beautification
    })

    // Add custom renderer rule for links
    const defaultRender = this.md.renderer.rules.link_open || function(tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options)
    }

    this.md.renderer.rules.link_open = function(tokens, idx, options, env, self) {
      const hrefIndex = tokens[idx].attrIndex('href')
      const href = tokens[idx].attrs[hrefIndex][1]

      // Check if href contains ops_provider_tasks
      if (href.includes('ops_provider_tasks')) {
        tokens[idx].attrPush(['data-turbo-frame', 'modal'])
      } else {
        tokens[idx].attrPush(['target', '_blank'])
        tokens[idx].attrPush(['rel', 'noopener noreferrer'])
      }

      return defaultRender(tokens, idx, options, env, self)
    }

    this.element.innerHTML = this.md.render(this.originalContentValue)
    window.dispatchEvent(new CustomEvent("markdown:rendered"))
  }
}
